import Image from 'next/image';

import { styled } from '@mui/system';

export const BrandsWrapper = styled('div')<{
  showLeftFade?: boolean;
  showRightFade?: boolean;
}>(() => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
}));

interface BrandRowProps {
  colCount: number;
  isSingleRow: boolean;
  hasRightChevron?: boolean;
}

const hideScrollbar = {
  scrollbarWidth: 'none' as const,
  msOverflowStyle: 'none' as const,
  '&::-webkit-scrollbar': {
    display: 'none',
    width: 0,
    height: 0,
  },
};

export const BrandRow = styled('div', {
  shouldForwardProp: (prop) =>
    !['colCount', 'isSingleRow', 'hasRightChevron'].includes(prop as string),
})<BrandRowProps>(({ theme }) => ({
  display: 'grid',
  gridTemplateRows: 'repeat(2, auto)',
  gridAutoFlow: 'column',
  alignItems: 'flex-start',
  gridTemplateColumns: `repeat(9, 0fr)`,
  gap: theme.spacing(2),
  width: 'max-content',
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(0.75),
  },
}));

export const PopularBrandContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const BrandWrapperStyle = styled('div')(({ theme }) => ({
  width: theme.spacing(9),
  height: theme.spacing(9),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto',
  cursor: 'pointer',
}));

export const BrandItemStyle = styled(Image)(({ theme }) => ({
  width: theme.spacing(8),
  height: theme.spacing(8),
  borderRadius: '50%',
  objectFit: 'contain',
  background: theme.palette.common.mds_global_color_white,
  border: '1px solid',
  borderColor: theme.palette.common.mds_global_color_grey_10,
  display: 'block',
}));

export const BrandsScrollContainer = styled('div')(() => ({
  flex: 1,
  overflowX: 'auto',
  overflowY: 'visible',
  ...hideScrollbar,
}));
